/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import ReactSVG from 'react-svg';
import { History } from 'history';
import { Box } from 'grommet';
import { BrandColors, LoneIconButton } from '@blend/enterprise-components';

export namespace Sidebar {
  export interface Props {
    highButtons: React.ReactElement[];
    isWide?: boolean; // TODO use this when implementing Notary Sidebar
    lowButtons: React.ReactElement[];
    rootRoutes: string[];
  }
}
/**
 * This component is intended to eventually become the only Sidebar Component in
 * the Workspace Application. Since it will be a large undertaking to move every
 * persona and every usecase over to this component at once, only personas that
 * have a `getSidebar` function defined for them will use this component.
 *
 * TODO: once all personas use this component, we can remove both the
 * getProfileSidebar function and the SidebarImplementedPersona interface from
 * personas.
 */
export const Sidebar: React.FC<Sidebar.Props> = ({ highButtons, lowButtons, rootRoutes }) => {
  const [isAtRoot, setIsAtRoot] = useState<boolean>(true);
  const history: History = useHistory();
  const location = useLocation();

  useEffect(() => {
    setIsAtRoot(rootRoutes.includes(location.pathname));
  }, [location.pathname]);

  return (
    <Box
      background={BrandColors.NIGHT}
      direction="column"
      flex={{ grow: 0, shrink: 0 }}
      height="100vh"
      justify="between"
      pad="20px"
    >
      <Box>
        {/* accomodate for differernce in icon height */}
        <Box margin={{ bottom: isAtRoot ? '40px' : '50px' }}>
          {isAtRoot ? (
            <ReactSVG path="./assets/blend-logo-white.svg" />
          ) : (
            <LoneIconButton btnSize="sm" icon="arrow_back" iconSize={24} onClick={history.goBack} theme="light" />
          )}
        </Box>

        <Box id="it-sidebar-high-buttons">
          {highButtons.map((button, idx) => (
            <Box key={button.key || idx} margin={{ bottom: '20px' }}>
              {button}
            </Box>
          ))}
        </Box>
      </Box>

      <Box id="it-sidebar-low-buttons">
        {lowButtons.map((button, idx) => (
          <Box key={button.key || idx} margin={{ top: '20px' }}>
            {button}
          </Box>
        ))}
      </Box>
    </Box>
  );
};
